var __jsx = React.createElement;
/* eslint-disable react/forbid-prop-types */
import React from 'react';
import { Box, Container, Grid } from '@mui/material';
import HeaderWithSidebar from '../HeaderWithSidebar';
import Link from '../../atoms/Link';
import { TopSection, OrganisationContainer, Title, OrgAvatar } from './style';
import Typography from '../../atoms/Typography';
import { useTranslation } from '../../../config/i18n';
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
var OpportunityDetailsTemplate = function OpportunityDetailsTemplate(_ref) {
  var children = _ref.children,
    title = _ref.title,
    background = _ref.background;
  var _useTranslation = useTranslation('organisations'),
    t = _useTranslation.t;
  return /*#__PURE__*/_jsxs(HeaderWithSidebar, {
    contentPadding: 0,
    children: [/*#__PURE__*/_jsx(TopSection, {
      background: background,
      children: /*#__PURE__*/_jsx(Container, {
        maxWidth: "xl",
        children: /*#__PURE__*/_jsx(Grid, {
          container: true,
          children: /*#__PURE__*/_jsx(Grid, {
            item: true,
            md: 8,
            sm: 12,
            xs: 12
          })
        })
      })
    }), title && /*#__PURE__*/_jsx(Title, {
      variant: "h2",
      align: "center",
      gutterBottom: true,
      children: title
    }), children]
  });
};
OpportunityDetailsTemplate.defaultProps = {
  title: undefined,
  background: ''
};
export default OpportunityDetailsTemplate;